import React, { Component } from 'react';
import './Footer.css'

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <Grid container style={{ backgroundColor: '#22292f', paddingBottom: '1rem', paddingTop: '1rem' }} justify="center">
          <Grid item xs={10}>
            <Grid container spacing={32}>
              <Grid item xs={12} sm={6}>
                <div style={{ textAlign: 'center' }}>
                  <img style={{ height: '100%',borderRadius: '100%' }} src="./logot.svg" alt="UCL Logo"/>
                  <Typography variant="h6" style={{ color: '#fff' }}>
                    USPCodeLab Sanca
                  </Typography>
                  <Typography variant="subtitle1" style={{ color: '#fff' }}>
                    Estimulando a inovação tecnológica na USP
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center' }}>
                  <a href="https://t.me/joinchat/FekGdUjtMuzsUzP-3XzZDQ" rel="noopener noreferrer" target="_blank" class="telegram" style={{ backgroundColor: '#f8f9fa', fontSize: '32px', borderRadius: '100%', paddingLeft: '6px', paddingRight: '6px', marginLeft: '8px', marginRight: '8px' }}>
                    <i class="fab fa-telegram"></i>
                  </a>
                  <a href="https://www.facebook.com/uspcodelabsanca" rel="noopener noreferrer" target="_blank" class="facebook" style={{ backgroundColor: '#f8f9fa', fontSize: '32px', borderRadius: '100%', paddingLeft: '7.5px', paddingRight: '7.5px', marginLeft: '8px', marginRight: '8px' }}>
                    <i class="fab fa-facebook"></i>
                  </a>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Footer;